import { Injectable } from '@angular/core';

import { EnabledAppService } from '../services/enabled-app/enabled-app.service';

@Injectable({ providedIn: 'root' })
export class EnabledAppFacade {
  public apps$             = this._service.apps$;
  public appId$            = this._service.appId$;
  public courses$          = this._service.courses$;
  public courseId$         = this._service.courseId$;
  public coursesFiltered$  = this._service.coursesFiltered$

  public updateAppId = this._service.updateAppId.bind(this._service);
  public updateCourseId = this._service.updateCourseId.bind(this._service);

  constructor(private readonly _service: EnabledAppService) {}
}
